import PurebrandLoader from "components/Loader/PurebrandLoader";
import NavComponent from "components/Navigation/NavComponent";
import AuthContext from "context/AuthContext";
import DataContext from "context/DataContext";
import ProfileContext from "context/ProfileContext";
import IncompleteProfile from "Pages/dashboard/Profile/IncompleteProfile";
import React, { useContext, useEffect, useState } from "react";
import { Tabs } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import "./hostlisting.css";
import LogContext from "context/LogContext";
import HostApprovals from "./HostApprovals";
import HostsProSoftList from "./HostsProSoftList";
import HostRevenueList from "./HostRevenueList";
import HostLogbookList from "./HostLogbookList";
import DemoContext from "context/DemoContext";
import FallbackHostList from "./FallbackHostList";
import HostRecruitment from "../HostRecruitment/HostRecruitment";
import useCan from "hooks/useCan";
import { CAPABILITIES } from "utils/capabilities";

const ViewHost = () => {
  let { userProfile } = useContext(AuthContext);
  const { can } = useCan();
  let {
    updatedHosts,
    updateHostRequests,
    updateHostRevenue,
    updatedRevenue,
    updateHostRequestsOnce,
    countUpdatedHosts,
  } = useContext(ProfileContext);
  const { fallbackHostCount, getAllFallbackHost, fetchAllHosts } = useContext(DemoContext);
  const { shopifyEmaillistAll } = useContext(DataContext);
  const [loading, setLoading] = useState(true);
  let { getAllHostLogbook, allLogbookCount } = useContext(LogContext);

  useEffect(() => {
    setLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;
    let first = updateHostRequests("?order=true&active=false", { signal });
    let second = updateHostRevenue("order=true", { signal });
    let third = shopifyEmaillistAll(
      userProfile?.store?.store_id,
      "?order=true",
      { signal }
    );
    let fourth = updateHostRequestsOnce("?order=true", {
      signal,
    });
    let fifth = getAllHostLogbook("?order=true", { signal });
    let sixth = getAllFallbackHost("?order=true", { signal });
    const promise = Promise.all([first, second, third, fourth, fifth, sixth]);
    promise
      .then((data) => {
        setLoading(false);
        // console.log(data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });

    fetchAllHosts('?')
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });

    return () => {
      controller.abort();
    };
  }, []);

  if (can(CAPABILITIES.HOSTS_VIEW)) {
    if (loading) {
      return <PurebrandLoader />;
    } else {
      if (!userProfile?.complete_profile) {
        return <IncompleteProfile />;
      }
      return (
        <>
          <div className="navigation-product-menu">
            <h5 className="text-start">Real Customer Requests</h5>
          </div>
          <div className="requests-wrapper">
            <Tabs
              defaultActiveKey="request"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <NavComponent
                eventKey="request"
                title={`Review Approvals (${
                  updatedHosts ? Array.from(new Map(updatedHosts.map(h => [h.id, h])).values()).length : 0
                })`}
                className=" host-request-wrapper"
              >
                <HostApprovals />
              </NavComponent>
              <NavComponent
                eventKey="allHosts"
                title={`Real Customer`}
                className=" host-request-wrapper"
              >
                <HostsProSoftList />
              </NavComponent>
              <NavComponent
                eventKey="hosts"
                title={`Real Customer Revenues `}
                className="host-list-wrapper"
              >
                <HostRevenueList />
              </NavComponent>
              {/* TODO: Need to uncomment this once prospective hosts feature is ready */}

              {/* <NavComponent
                eventKey="prospective"
                title={`Prospective (${
                  countProspective ? countProspective : 0
                })`}
                className="host-list-wrapper"
              >
                <HostProspectiveList />
              </NavComponent> */}
              <NavComponent
                eventKey="hostrecruitment"
                title={`Real Customer Recruitment`}
                className="host-list-wrapper"
              >
                <HostRecruitment />
              </NavComponent>
              <NavComponent
                eventKey="fallbackhost"
                title={`Fallback Real Customer `}
                className="host-list-wrapper"
              >
                <FallbackHostList />
              </NavComponent>
              <NavComponent
                eventKey="logbook"
                title={`Log Book `}
                className="host-list-wrapper"
              >
                <HostLogbookList />
              </NavComponent>
            </Tabs>
          </div>
        </>
      );
    }
  } else {
    return <Navigate to="/user/welcome" />;
  }
};

export default ViewHost;
